import type { Price } from '@packages/domain/models/price';
import {
  FETCH_OFFERS_SUCCESS,
  FETCH_RECURRING_OFFERS_SUCCESS,
} from 'constants/offers';
import {
  CREATE_PAYMENT_SUCCESS,
  FETCH_PAYMENT_SUCCESS,
} from 'constants/payment';

type PricesActions = {
  type:
    | typeof CREATE_PAYMENT_SUCCESS
    | typeof FETCH_OFFERS_SUCCESS
    | typeof FETCH_RECURRING_OFFERS_SUCCESS
    | typeof FETCH_PAYMENT_SUCCESS;
  payload: {
    entities: {
      prices: Record<string, Price>;
    };
  };
};

const prices = (state: Record<string, Price> = {}, action: PricesActions) => {
  switch (action.type) {
    case CREATE_PAYMENT_SUCCESS:
    case FETCH_OFFERS_SUCCESS:
    case FETCH_RECURRING_OFFERS_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { prices = {} },
      } = action.payload;
      return { ...state, ...prices };
    default:
      return state;
  }
};

export { prices };
